'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style"];
import * as React from 'react';
import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { CompositeList } from "../../base-ui-copy/composite/list/CompositeList.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export const CalendarGridTimeScrollableContent = /*#__PURE__*/React.forwardRef(function CalendarGridScrollableContent(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const ref = React.useRef(null);
  const columnsRefs = React.useRef([]);
  React.useEffect(() => {
    // TODO: Try to add the behavior back in the test
    // For now, it causes the following error in JSDOM:
    // "Auto scrolling has been attached to an element that appears not to be scrollable"
    if (!ref.current || process.env.NODE_ENV === 'test') {
      return undefined;
    }
    return autoScrollForElements({
      element: ref.current
    });
  });
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef, ref],
    props: [elementProps]
  });
  return /*#__PURE__*/_jsx(CompositeList, {
    elementsRef: columnsRefs,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridTimeScrollableContent.displayName = "CalendarGridTimeScrollableContent";